/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Getting_StartedInputs */

const en_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Started`)
};

const de_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Schritte`)
};

const fr_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premiers pas`)
};

const es_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeros pasos`)
};

const it_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare`)
};

const nl_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan de slag`)
};

const pl_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpoczęcie`)
};

const fi_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloitus`)
};

const da_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang`)
};

const sv_help_getting_started = /** @type {(inputs: Help_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång`)
};

/**
* | output |
* | --- |
* | "Getting Started" |
*
* @param {Help_Getting_StartedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_getting_started = /** @type {((inputs?: Help_Getting_StartedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Getting_StartedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_getting_started(inputs)
	if (locale === "fr") return fr_help_getting_started(inputs)
	if (locale === "es") return es_help_getting_started(inputs)
	if (locale === "it") return it_help_getting_started(inputs)
	if (locale === "nl") return nl_help_getting_started(inputs)
	if (locale === "pl") return pl_help_getting_started(inputs)
	if (locale === "fi") return fi_help_getting_started(inputs)
	if (locale === "da") return da_help_getting_started(inputs)
	if (locale === "sv") return sv_help_getting_started(inputs)
	return en_help_getting_started(inputs)
});